import { ScrollRevealWrapper } from '../../../components/feature/ScrollRevealWrapper';
import { Link } from 'react-router-dom';

const beneficios = [
  {
    icone: 'ri-heart-line',
    titulo: 'Clareza Emocional',
    descricao: 'Compreenda e processe suas emoções de forma saudável, desenvolvendo inteligência emocional e equilíbrio interior para liderar com presença.',
  },
  {
    icone: 'ri-lightbulb-line',
    titulo: 'Autoconhecimento Profundo',
    descricao: 'Descubra seus padrões, crenças e potenciais ocultos através de exercícios guiados de reflexão e escrita terapêutica.',
  },
  {
    icone: 'ri-shield-check-line',
    titulo: 'Confiança Renovada',
    descricao: 'Fortaleça sua autoestima através da ressignificação de experiências e ancoragem de estados de alta performance.',
  },
  {
    icone: 'ri-compass-3-line',
    titulo: 'Propósito Claro',
    descricao: 'Identifique seus valores essenciais e alinhe suas ações com seu propósito de vida autêntico e profissional.',
  },
  {
    icone: 'ri-refresh-line',
    titulo: 'Transformação Real',
    descricao: 'Crie mudanças duradouras através de práticas diárias que reprogramam sua mente para resultados de alta performance.',
  },
  {
    icone: 'ri-sparkling-line',
    titulo: 'Manifestação Consciente',
    descricao: 'Aprenda a atrair e materializar seus objetivos através de técnicas comprovadas de visualização e gratidão ativa.',
  },
];

export default function Beneficios() {
  return (
    <section id="beneficios" className="py-24 bg-[#0a0a0a] relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_20%,rgba(201,164,64,0.06),transparent_50%)]"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_80%,rgba(201,164,64,0.04),transparent_50%)]"></div>
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <ScrollRevealWrapper animation="fade-up">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-4 mb-6">
              <div className="h-px w-10 bg-gradient-to-r from-transparent to-gold-500/60"></div>
              <span className="text-gold-400 text-xs font-semibold tracking-[0.35em] uppercase font-['Montserrat']">
                Benefícios
              </span>
              <div className="h-px w-10 bg-gradient-to-l from-transparent to-gold-500/60"></div>
            </div>
            <h2 className="font-display text-5xl md:text-6xl font-bold text-white mb-5 leading-tight">
              O Que Você Vai <span className="text-gold-400">Conquistar</span>
            </h2>
            <p className="text-lg text-white/50 max-w-2xl mx-auto leading-relaxed font-['Montserrat'] font-light">
              Transformações reais e mensuráveis que vão impactar todas as áreas da sua vida
            </p>
          </div>
        </ScrollRevealWrapper>

        {/* Grid de Benefícios */}
        <div className="grid md:grid-cols-3 gap-5 mb-16">
          {beneficios.map((b, i) => (
            <ScrollRevealWrapper key={i} animation="fade-up" delay={0.07 * i}>
              <div className="group bg-[#111111] rounded-xl p-7 border border-gold-500/10 hover:border-gold-500/35 transition-all duration-400 hover:-translate-y-1">
                <div className="w-12 h-12 bg-gradient-to-br from-gold-500 to-gold-700 rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${b.icone} text-xl text-[#0a0a0a]`}></i>
                </div>
                <h3 className="text-base font-bold text-white mb-2 font-display">{b.titulo}</h3>
                <p className="text-white/45 leading-relaxed text-sm font-['Montserrat']">{b.descricao}</p>
              </div>
            </ScrollRevealWrapper>
          ))}
        </div>

        {/* Garantia */}
        <ScrollRevealWrapper animation="fade-up" delay={0.3}>
          <div className="flex flex-col md:flex-row items-center gap-8 bg-gradient-to-r from-[#1a1400] to-[#0f0c00] border border-gold-500/25 rounded-2xl p-10">
            <div className="w-16 h-16 flex-shrink-0 flex items-center justify-center bg-gold-500/12 border border-gold-500/20 rounded-full">
              <i className="ri-shield-check-line text-3xl text-gold-400"></i>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="font-display text-2xl font-bold text-white mb-2">Garantia de Satisfação Total</h3>
              <p className="text-white/50 leading-relaxed font-['Montserrat'] text-sm">
                Experimente o método por 7 dias. Se não sentir resultados reais, devolvemos 100% do seu investimento — sem perguntas, sem burocracia.
              </p>
            </div>
            <div className="flex flex-wrap gap-4 flex-shrink-0">
              {['7 Dias de Garantia', '100% Reembolso', 'Sem Burocracia'].map((item) => (
                <div key={item} className="flex items-center gap-2 text-white/70">
                  <i className="ri-check-line text-gold-400"></i>
                  <span className="font-medium text-sm font-['Montserrat']">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </ScrollRevealWrapper>

        {/* CTA */}
        <ScrollRevealWrapper animation="fade-up" delay={0.4}>
          <div className="text-center mt-10">
            <Link
              to="/planos"
              className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-gold-500 to-gold-700 text-[#0a0a0a] font-bold rounded-full hover:from-gold-600 hover:to-gold-800 transition-all whitespace-nowrap font-['Montserrat'] text-sm tracking-wide"
            >
              Começar Minha Transformação
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </ScrollRevealWrapper>
      </div>
    </section>
  );
}
